import { create } from 'zustand';

type UseFolderStatusState = {
  isFolderStatusPendingRequest?: boolean;
};

export const useFolderStatusState = create<UseFolderStatusState>(() => ({}));
